import React from 'react';
import { useSeasonContext } from './SeasonContext';
import GarlandLights from './lights/GarlandLights';

interface SeasonalLightsProps {
    lightCount?: number;
}

const SeasonalLights: React.FC<SeasonalLightsProps> = ({ lightCount = 20 }) => {
    const { config } = useSeasonContext();

    return <GarlandLights config={config.lights} lightCount={lightCount} />;
};

export default SeasonalLights;
